module.exports = __webpack_public_path__ + "static/process3-ea11a60293e303433da5ff95899b01d8.jpeg";